<template>
  <div id="login-container">
    <el-row :gutter="24" class="row">
      <el-col :span="24" class="title">{{$regional.showName}}学生综合素质评价系统</el-col>
      <el-col :span="24" class="form-column">
        <span class="forget-pass">忘记密码</span>

        <el-steps
          :active="step"
          align-center
          style="width: 50%; margin: 20px auto 0 auto"
        >
          <el-step title="确认账号" :class="step === 2 ? 'second-step' : ''">
            <i class="iconfont icon-dot" slot="icon"></i>
          </el-step>
          <el-step title="重置密码">
            <i class="iconfont icon-dot" slot="icon"></i>
          </el-step>
        </el-steps>

        <el-form
          v-if="step === 1"
          ref="checkForm"
          :model="checkForm"
          :rules="checkRule"
          class="login-form"
          label-position="left"
          label-width="0px"
          v-loading="loading"
        >
          <el-form-item prop="account">
            <label for="account" class="common-label">手机号</label>
            <el-input
              id="account"
              type="text"
              v-model="checkForm.account"
              auto-complete="off"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <el-form-item prop="captcha" style="width: 100%">
            <label for="captcha" class="common-label">验证码</label>
            <el-input
              class="captcha"
              id="captcha"
              type="text"
              style="position: relative"
              v-model="checkForm.captcha"
              auto-complete="off"
              placeholder="请输入验证码"
            ></el-input>
            <el-button
              class="captcha"
              type="text"
              style="position: absolute; right: 0px"
              @click.prevent="receiveCaptcha"
              :disabled="(disabled = !show)"
            >
              <span v-show="show" class="get-captcha">获取验证码</span>
              <span v-show="!show" class="count">{{ count }}s后重新获取</span>
            </el-button>
          </el-form-item>
          <el-form-item style="width: 100%">
            <el-button type="primary" class="next-button" @click="checkAccount"
              >下一步</el-button
            >
          </el-form-item>
        </el-form>

        <el-form
          v-if="step === 2"
          ref="resetForm"
          :model="resetForm"
          :rules="resetRule"
          class="login-form"
          label-position="left"
          label-width="0px"
          v-loading="loading"
        >
          <el-form-item prop="password">
            <label for="password" class="common-label">新密码</label>
            <el-input
              type="password"
              id="password"
              v-model="resetForm.password"
              auto-complete="off"
              :maxlength="20"
              placeholder="请输入新密码"
            ></el-input>
          </el-form-item>
          <el-form-item prop="checkPassword">
            <label for="checkPassword" class="common-label">确认新密码</label>
            <el-input
              type="password"
              id="checkPassword"
              v-model="resetForm.checkPassword"
              auto-complete="off"
              :maxlength="20"
              placeholder="请再次输入新密码"
            ></el-input>
          </el-form-item>
          <el-form-item style="width: 100%">
            <el-button type="primary" class="next-button" @click="checkPwd"
              >重新登录</el-button
            >
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import md5 from 'js-md5'

const TIME_COUNT = 60 // 更改倒计时时间
export default {
  data () {
    var validatePhone = (rule, value, callback) => {
      if (/^(?:\+?86)?1(?:3\d{3}|5[^4\D]\d{2}|8\d{3}|7(?:[235-8]\d{2}|4(?:0\d|1[0-2]|9\d))|9[0-35-9]\d{2}|66\d{2})\d{6}$/.test(value) === false) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'))
      } else {
        if (/^[A-Za-z0-9]+$/.test(value) === false) {
          callback(new Error('密码仅支持包含英文字母和数字'))
        } else {
          callback()
        }
        if (this.resetForm.checkPassword !== '') {
          this.$refs.resetForm.validateField('checkPassword')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新密码'))
      } else if (value !== this.resetForm.password) {
        callback(new Error('两次密码输入不一致，请重新输入'))
      } else if (/^[A-Za-z0-9]+$/.test(value) === false) {
        callback(new Error('密码仅支持包含英文字母和数字'))
      } else {
        callback()
      }
    }
    return {
      step: 1,
      checkRule: {
        account: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        captcha: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      resetRule: {
        password: [
          { validator: validatePass, trigger: 'blur' },
          { min: 6, message: '长度至少 6 个字符', trigger: 'blur' },
          { max: 20, message: '长度最多 20 个字符', trigger: 'blur' }
        ],
        checkPassword: [
          { validator: validatePass2, trigger: 'blur' },
          { min: 6, message: '长度至少 6 个字符', trigger: 'blur' },
          { max: 20, message: '长度最多 20 个字符', trigger: 'blur' }
        ]
      },
      checked: true,
      checkForm: { account: '', captcha: '' },
      resetForm: { password: '', checkPassword: '' },
      loading: false,
      show: true, // 初始启用按钮
      count: '', // 初始化次数
      timer: null,
      errorMsg: ''
    }
  },

  mounted () {
  },

  methods: {
    checkAccount: function () {
      this.$refs['checkForm'].validate(valid => {
        if (valid) {
          this.$xhrPost('/acc/sms/verification/anon', {
            code: this.checkForm.captcha,
            phone: this.checkForm.account
          }).then(rs => {
            if (rs.code === 'SUCCESS' && rs.data === 'OK') {
              localStorage.setItem('account', this.checkForm.account)
              localStorage.setItem('code', this.checkForm.captcha)
              this.loading = true
              this.step = 2
              setTimeout(() => {
                this.$refs.checkForm && this.$refs.checkForm.resetFields()
                this.$refs.resetForm && this.$refs.resetForm.resetFields()
              }, 10)
              setTimeout(() => {
                this.loading = false
              }, 400)
            } else if (rs.code === 'SUCCESS' && rs.data === 'illegal') {
              this.$message.error('手机号码与接收验证码手机号码不一致')
            } else if (rs.code === 'SUCCESS' && rs.data === 'isv.BUSINESS_LIMIT_CONTROL') {
              this.$message.error('超出同一手机号一天之内 5 条短信限制')
            } else if (rs.code === 'SUCCESS' && rs.data === 'overdue') {
              this.$message.error('验证码超时')
            } else if (rs.code === 'SUCCESS' && rs.data === 'code-error') {
              this.$message.error('验证码错误')
            }
          })
        }
      })
    },
    checkPwd () {
      this.$refs['resetForm'].validate((valid) => {
        if (valid) {
          let account = localStorage.getItem('account')
          let code = localStorage.getItem('code')
          this.$xhrPut('/acc/password/anon', {
            phone: account,
            code: code,
            password: md5(this.resetForm.password + 'p@w123!@#')
          }).then(rs => {
            this.loading = false
            if (rs.code === 'SUCCESS' && !rs.data) {
              this.loading = true
              this.$message.success('重置密码成功，正在跳转到登录')
              setTimeout(() => {
                this.directLogin()
                localStorage.clear()
              }, 500)
            } else if (rs.code === 'SUCCESS' && rs.data === 'overdue') {
              this.$message.error('验证码超时')
            } else if (rs.code === 'SUCCESS' && rs.data === 'illegal') {
              this.$message.error('手机号码与接收验证码手机号码不一致')
            } else if (rs.code === 'SUCCESS' && rs.data === 'isv.BUSINESS_LIMIT_CONTROL') {
              this.$message.error('超出同一手机号一天之内 5 条短信限制')
            } else if (rs.code === 'SUCCESS' && rs.data === 'code-error') {
              this.$message.error('验证码错误')
            }
          })
        }
      })
    },
    receiveCaptcha () {
      let account = this.checkForm.account
      let reg = /^1[34578]\d{9}$/
      if (reg.test(account) === false) {
        let account = document.getElementById('account')
        account.focus()
        this.errorMsg = '请输入正确的手机号'
        return false
      }
      let captcha = document.getElementById('captcha')
      captcha.focus()
      // 发送验证码请求
      this.$xhrGet(`/acc/sms/code/anon`, { phone: this.checkForm.account }).then(rs => {
        if (rs.code === 'SUCCESS' && !rs.data) {
          if (!this.timer) {
            this.count = TIME_COUNT
            this.show = false
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--
              } else {
                this.show = true
                clearInterval(this.timer) // 清除定时器
                this.timer = null
              }
            }, 1000)
          }
        } else if (rs.code === 'SUCCESS' && rs.data === 'unknown_phone') {
          this.$message.error('当前手机号在系统中不存在')
        } else if (rs.code === 'SUCCESS' && rs.data === 'isv.BUSINESS_LIMIT_CONTROL') {
          this.$message.error('超出同一手机号一天之内 5 条短信限制')
        } else if (rs.code === 'SUCCESS' && rs.data === 'frequent-error') {
          this.$message.error('同一手机号码同一分钟之内发送频率不能超过1条')
        } else if (rs.code === 'SUCCESS' && rs.data === 'account_locked') {
          this.$message.error('账户已锁定，不支持修改密码')
        }
      })
    },
    directLogin () {
      let loginType = this.$route.query.loginType
      this.$router.push({ name: 'Login', query: { loginType: loginType } })
    }
  }
}
</script>

<style lang="scss" scoped>
#login-container {
  background-color: #f8fafc;
  background-position: center;
  background-size: 100%;
  text-align: left;
  width: 100%;
  height: 100%;
  background-color: #f8fafc;
}
.login-form {
  background-clip: padding-box;
  background: #fff;
  margin: 40px auto 40px auto;
  width: 40%;
}
.login-tips p {
  line-height: 15px;
}
.forget-pwd {
  color: #5d94f3;
  font-size: 14px;
  text-align: right;
  margin: 0px auto;
  cursor: pointer;
}
.span-button {
  color: #5e93f6;
  cursor: pointer;
  font-size: 14px;
}
.el-form /deep/ .el-button.is-plain {
  background: #fff;
}
.el-form /deep/ .el-button.is-plain:hover {
  background: #eff4fe;
  color: #5e93f6;
}
.captcha /deep/ .el-input__inner {
  z-index: 1;
}
#login-container /deep/ button.captcha {
  border-radius: 0;
}
/deep/ .el-input__inner {
  width: 100%;
  padding-left: 0;
  border-radius: 0;
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 1px;
}
.common-label {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  font-weight: 400;
  color: #444444;
}
.row {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 85%;
  height: 100%;
  padding: 100px 200px;
}
.title {
  height: 42px;
  font-size: 30px;
  font-weight: 500;
  color: #444444;
  line-height: 42px;
}
.form-column {
  width: 100%;
  margin-top: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 4px 16px 0px rgba(33, 33, 33, 0.12);
}
.forget-pass {
  display: inline-block;
  width: 100%;
  height: 33px;
  margin: 40px auto 0 auto;
  text-align: center;
  font-size: 24px;
  font-weight: 500;
  color: #4a4a4a;
  line-height: 33px;
}
.get-captcha {
  font-size: 16px;
  font-weight: 400;
  color: var(--theme-color);
}
.next-button {
  width: 100%;
  background: var(--theme-color);
  border-radius: 20px;
  margin-top: 10px;
}
.el-step /deep/ .el-step__icon {
  border: none;
}
/deep/ .is-process {
  color: #9b9b9b !important;
}
.second-step /deep/ .is-finish {
  color: #9b9b9b !important;
}
/deep/ .el-step__title {
  font-size: 14px;
}
/deep/ .el-step__line-inner {
  border-color: #cccccc !important;
}
/deep/ input::-webkit-input-placeholder {
  /* 修改字号，默认继承input */
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/ForgetPwd.vue